import React from "react";
import { iconProps } from "../../../../Helper";

export const GenerateLogoIcon = ({ className }: iconProps) => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect
        className={`${className}-stroke`}
        x="13.3889"
        y="0.444444"
        width="2.66667"
        height="2.66667"
        stroke="white"
        strokeWidth="0.888889"
      />
      <rect
        className={`${className}-stroke`}
        x="0.944444"
        y="0.444444"
        width="2.66667"
        height="2.66667"
        stroke="white"
        strokeWidth="0.888889"
      />
      <rect
        className={`${className}-stroke`}
        x="0.944444"
        y="12.8898"
        width="2.66667"
        height="2.66667"
        stroke="white"
        strokeWidth="0.888889"
      />
      <rect
        className={`${className}-stroke`}
        x="13.3889"
        y="12.8898"
        width="2.66667"
        height="2.66667"
        stroke="white"
        strokeWidth="0.888889"
      />
      <path
        className={className}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.38892 2.66667V13.3333H2.2778V2.66667H1.38892ZM13.8333 15.1109H3.16667V14.222H13.8333V15.1109ZM15.6111 13.3333V2.66667H14.7222V13.3333H15.6111ZM3.16667 1.77756H13.8333V0.888672H3.16667V1.77756Z"
        fill="white"
      />
      <path
        className={`${className}-stroke`}
        d="M8.49986 5.92773V10.0759M6.42578 8.00181H10.5739"
        stroke="white"
        strokeWidth="0.592593"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
